export default __webpack_public_path__ + "static/media/groupSelected.addbccf7.svg";